module.exports = __webpack_public_path__ + "img/lever04.32949bb3.png";